const $searchForm = $('.js-jobs-search-form');

$(document).ready(function () {

    // Group Filter: Reset and Submit dropdown menu buttons management.
    $(document).on('click', '.js-group-filter-submit-btn', function (e) {
        refreshGroupFilterText();
        $searchForm.submit();
    });

    $(document).on('click', '.js-group-filter-reset-btn', function (e) {
        const $dropdownMenu = $(this).closest('.dropdown-menu');
        resetDropdownMenu($dropdownMenu);
        refreshGroupFilterText();
    });

    // Region Filter: Reset and Submit dropdown menu buttons management.
    $(document).on('click', '.js-region-filter-submit-btn', function (e) {
        updateRegionHiddenInput();
        refreshRegionFilterText();
        $searchForm.submit();
    });

    $(document).on('click', '.js-region-filter-reset-btn', function (e) {
        const $dropdownMenu = $(this).closest('.dropdown-menu');
        resetDropdownMenu($dropdownMenu);
        updateRegionHiddenInput();
        refreshRegionFilterText();
    });

    var refreshGroupFilterText = function () {
        refreshFilterButtonText($searchForm.find(".js-group-filter"), "Domaines");
    };

    var refreshRegionFilterText = function () {
        refreshFilterButtonText($searchForm.find(".js-region-filter"), "Localisation");
    };

    var resetDropdownMenu = function ($dropdownMenu) {
        $dropdownMenu.find(':checkbox').prop('checked', false);
    };

    var refreshFilterButtonText = function ($filterElt, defautText) {
        const $btnFilter = $filterElt.find(".btn-filter");
        let $checkedItems = $filterElt.find("input:checked");
        if ($checkedItems.length > 0) {
            let selectedFilterText = "";
            $checkedItems.each(function (itemIndex, elt) {
                const checkedItemLabel = $filterElt.find('label[for="' + $(this).attr('id') + '"]').text();
                if (itemIndex === 0) {
                    selectedFilterText = checkedItemLabel;
                }
                else if (itemIndex < 1) {
                    selectedFilterText += ", " + checkedItemLabel;
                }
                else {
                    selectedFilterText += ", +" + ($checkedItems.length - 1).toString();
                    return false;
                }
            });
            $btnFilter.text(selectedFilterText);
            $btnFilter.toggleClass("active", true);
        }
        else {
            $btnFilter.text(defautText);
            $btnFilter.toggleClass("active", false);
        }
    };

    // Region filter values are maintained into an hidden input.
    var updateRegionHiddenInput = function () {
        const $hiddenInput = $searchForm.find(".js-hidden-input-regions");
        const $checkedItems = $searchForm.find(".js-region-filter input:checked");
        let hiddenVal = "";
        if ($checkedItems.length > 0) {
            $checkedItems.each(function (itemIndex, elt) {
                const regionCode = $(this).data("regionCode");
                if (itemIndex === 0) {
                    hiddenVal = regionCode;
                }
                else {
                    hiddenVal += "," + regionCode;
                }
            });
        }
        $hiddenInput.val(hiddenVal);
    };

    //Prevents the bootstrap dropdown menu close when clicked inside.
    $('.js-dropdown-dont-close').on({
        "click.bs.dropdown": function (e) {
            if (!$(e.target).is(".js-dropdown-footer > button")
                && !$(e.target).is(".js-dropdown-close-btn > span"))
                e.stopPropagation();
        }
    });

    //Prevents page scrolling when full-screen dropdown is open.
    $('.js-dropdown-dont-close').parent().on({
        "shown.bs.dropdown": function (e) {
            $("body").addClass("mobile-fixed-no-overflow");
        },
        "hidden.bs.dropdown": function (e) {
            $("body").removeClass("mobile-fixed-no-overflow");
        }
    });



    $searchForm.on('submit', function (e) {
        e.preventDefault();

        var filtersData = $searchForm.serialize();

        location.assign('/search?' + filtersData);
    });


    refreshGroupFilterText();
    refreshRegionFilterText();
}); 